module.exports = __webpack_public_path__ + "img/dark_box3_icon4.ed3204ac.png";